export const FEEDBACK = {
  EDITION_PENDING: {
    visible: true,
    type: 'info',
    message:
      'Se ha enviado correctamente el formulario de edición y está pendiente de confirmación',
  },
  TITLE_EDITION_PENDING: 'pendiente de edición',
};
